// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Socials_wrapper__1eeGF"};